"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenParsedApplicationResponseDetails = flattenParsedApplicationResponseDetails;
/** Merges all `pages[].responses[]` blocks into one flat key/value map. */
function getAllPageDataInObject(parsedDetails) {
    var returnObj = {};
    var pages = parsedDetails.pages;
    if (!Array.isArray(pages)) {
        return returnObj;
    }
    for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
        var page = pages_1[_i];
        if (!page || typeof page !== 'object')
            continue;
        var responses = page.responses;
        if (!Array.isArray(responses))
            continue;
        for (var _a = 0, responses_1 = responses; _a < responses_1.length; _a++) {
            var item = responses_1[_a];
            if (!item || typeof item !== 'object' || Array.isArray(item))
                continue;
            var record = item;
            for (var _b = 0, _c = Object.entries(record); _b < _c.length; _b++) {
                var _d = _c[_b], key = _d[0], value = _d[1];
                if (!key || (Array.isArray(value) && value.length === 0))
                    continue;
                if (!(key in returnObj)) {
                    returnObj[key] = value;
                }
                else if (Array.isArray(value) && value.length) {
                    var prev = returnObj[key];
                    returnObj[key] = Array.isArray(prev) ? __spreadArray(__spreadArray([], prev, true), value, true) : value;
                }
                else if (typeof value !== 'object' || value === null) {
                    returnObj[key] = value;
                }
                else {
                    var prev = returnObj[key];
                    returnObj[key] =
                        prev && typeof prev === 'object' && !Array.isArray(prev)
                            ? __assign(__assign({}, prev), value) : value;
                }
            }
        }
    }
    return returnObj;
}
/** Hoists nested `applicantData` onto the root of the flattened map. */
function transformObject(data) {
    var _a;
    var returnData = {};
    for (var _i = 0, _b = Object.keys(data); _i < _b.length; _i++) {
        var key = _b[_i];
        var value = data[key];
        if (key === 'applicantData' &&
            value &&
            typeof value === 'object' &&
            !Array.isArray(value)) {
            returnData = __assign(__assign({}, returnData), value);
        }
        else {
            returnData = __assign(__assign({}, returnData), (_a = {}, _a[key] = value, _a));
        }
    }
    return returnData;
}
/**
 * @param parsedDetails — result of `JSON.parse` on `application_response.details`, or the same shape for applicant response blobs.
 */
function flattenParsedApplicationResponseDetails(parsedDetails) {
    if (!parsedDetails ||
        typeof parsedDetails !== 'object' ||
        Array.isArray(parsedDetails)) {
        return {};
    }
    var root = parsedDetails;
    if (!Object.keys(root).length) {
        return {};
    }
    var merged = getAllPageDataInObject(root);
    return transformObject(merged);
}
